// The Firebase SDK is only needed to host or watch a shared session. A normal
// visit never calls this, so the chunk stays off the first load.
//
// Browsers keep a failed module download for the rest of the page's life
// (Chromium 145, WebKit 26): a second import() of the same file rejects
// without asking the network again. Forgetting the rejected promise still
// lets an engine that does refetch try again, but in today's browsers only a
// reload gets a fresh download. The game lives in localStorage, so Share's
// "Try again" reloads and reopens Share (reloadToRetryShare).

let realtimePromise: Promise<typeof import('./realtime')> | null = null;
let loadFailed = false;

export function loadRealtime() {
  realtimePromise ??= import('./realtime').catch((error: unknown) => {
    realtimePromise = null;
    loadFailed = true;
    throw error;
  });
  return realtimePromise;
}

/** Whether this page failed to download the realtime code. */
export const realtimeLoadFailed = () => loadFailed;

const REOPEN_SHARE_KEY = 'reopenShareWatch';

/** Reloads the page and reopens Share once it's back. */
export function reloadToRetryShare() {
  try {
    sessionStorage.setItem(REOPEN_SHARE_KEY, '1');
  } catch {
    // Without storage the player reopens Share themselves.
  }
  window.location.reload();
}

/** True once after reloadToRetryShare, for the Header to reopen Share. */
export function takeShareRetry(): boolean {
  try {
    if (sessionStorage.getItem(REOPEN_SHARE_KEY) === null) return false;
    sessionStorage.removeItem(REOPEN_SHARE_KEY);
    return true;
  } catch {
    return false;
  }
}

export function resetRealtimeLoadForTests() {
  realtimePromise = null;
  loadFailed = false;
}
